import { render } from "./IndexView.vue?vue&type=template&id=f3cb609c&scoped=true&ts=true"
import script from "./IndexView.vue?vue&type=script&lang=ts"
export * from "./IndexView.vue?vue&type=script&lang=ts"

import "./IndexView.vue?vue&type=style&index=0&id=f3cb609c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3cb609c"]])

export default __exports__